import { render } from "./ContactForm.vue?vue&type=template&id=75d8d935"
import script from "./ContactForm.vue?vue&type=script&lang=ts"
export * from "./ContactForm.vue?vue&type=script&lang=ts"
script.render = render

export default script